import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import Header from '../components/Header/Header';
import Footer from '../components/Footer/Footer';
import './Privacy.css';

const Privacy = () => {
  useEffect(() => {
    // Если в URL указан якорь (например, #consent), прокручиваем к нему,
    // иначе — в начало страницы.
    if (window.location.hash) {
      const id = window.location.hash.replace('#', '');
      const el = document.getElementById(id);
      if (el) {
        el.scrollIntoView({ behavior: 'smooth', block: 'start' });
        return;
      }
    }
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Header />
      <div className="privacy-page">
        <div className="container">
          <div>
            <Link to="/" className="back-link">
              <ArrowLeft size={20} />
              Вернуться на главную
            </Link>
            
            <h1>Политика конфиденциальности и согласие на обработку персональных данных</h1>

            <p className="privacy-date">Дата последнего обновления: 25 августа 2026 г.</p>

            <div className="privacy-content">
              <p>
                <strong>Оператор персональных данных:</strong> Индивидуальный предприниматель
                Загибалова Марина Александровна, ИНН 500403234260, ОГРНИП 325508100115316.
                Адрес для корреспонденции: 142119, а/я 479, Загибалова Марина Александровна.
                Контактный телефон:{' '}
                <a href="tel:+79257166607">+7 (925) 716-66-07</a>. Контактный e-mail для
                обращений по вопросам обработки персональных данных:{' '}
                <a href="mailto:trigru@ya.ru">trigru@ya.ru</a>.
              </p>

              <p>
                Настоящая Политика конфиденциальности персональных данных (далее – Политика) действует в
                отношении всей информации, которую сайт компании «МИГРАНТ PRO», расположенный на
                доменном имени https://мигрантпро.рф (далее – Сайт), может получить о Пользователе во время
                использования Сайта, его сервисов, программ и продуктов.
              </p>

              <p>
                Использование сервисов Сайта, включая отправку формы обратной связи, означает безоговорочное 
                согласие Пользователя с настоящей Политикой и указанными в ней условиями обработки его 
                персональной информации; в случае несогласия с этими условиями Пользователь должен 
                воздержаться от использования сервисов.
              </p>

              <h2>1. Персональная информация пользователей, которую обрабатывает Сайт</h2>
              
              <h3>1.1. В рамках настоящей Политики под «персональной информацией Пользователя» понимаются:</h3>
              
              <p>
                <strong>1.1.1.</strong> Персональная информация, которую Пользователь предоставляет о себе самостоятельно при 
                заполнении форм на Сайте, включая, но не ограничиваясь: Имя, Контактный номер телефона. 
                Обязательная для предоставления информация помечена специальным образом (например, звездочкой). 
                Иная информация предоставляется Пользователем на его усмотрение.
              </p>

              <p>
                <strong>1.1.2.</strong> Данные, которые автоматически передаются сервисам Сайта в процессе их использования с 
                помощью установленного на устройстве Пользователя программного обеспечения, в том числе 
                IP-адрес, данные файлов cookie, информация о браузере Пользователя (или иной программе, с 
                помощью которой осуществляется доступ к сервисам), технические характеристики оборудования и 
                программного обеспечения, используемых Пользователем, дата и время доступа к сервисам, адреса 
                запрашиваемых страниц и иная подобная информация. Эти данные используются для улучшения 
                работы сайта и анализа посещаемости.
              </p>

              <p>
                <strong>1.2.</strong> Настоящая Политика применима только к информации, обрабатываемой в ходе использования Сайта. 
                Сайт не контролирует и не несет ответственность за обработку информации сайтами третьих лиц, 
                на которые Пользователь может перейти по ссылкам, доступным на Сайте (например, виджеты 
                Яндекс Карт).
              </p>

              <p>
                <strong>1.3.</strong> Сайт не проверяет достоверность персональной информации, предоставляемой Пользователем, и не 
                имеет возможности оценивать его дееспособность. Однако Сайт исходит из того, что пользователь 
                предоставляет достоверную и достаточную персональную информацию и поддерживает эту 
                информацию в актуальном состоянии.
              </p>

              <h2>2. Цели обработки персональной информации пользователей</h2>
              
              <p><strong>2.1.</strong> Сайт собирает и хранит только ту персональную информацию, которая необходима для предоставления услуг или исполнения соглашений и договоров с Пользователем (например, для ответа на заявку), за исключением случаев, когда законодательством предусмотрено обязательное хранение персональной информации в течение определенного законом срока.</p>
              
              <h2>3. Условия обработки персональной информации пользователей и её передачи третьим лицам</h2>
              
              <p><strong>3.1.</strong> Сайт хранит персональную информацию Пользователей в соответствии с внутренними регламентами и требованиями законодательства РФ.</p>
              
              <p><strong>3.2.</strong> В отношении персональной информации Пользователя сохраняется ее конфиденциальность, кроме случаев добровольного предоставления Пользователем информации о себе для общего доступа неограниченному кругу лиц.</p>

              <p>
                <strong>3.3. Передача данных третьим лицам (обработчикам).</strong> Для обеспечения работы Сайта,
                аналитики посещаемости и обработки звонков Сайт использует следующие сервисы, которые
                выступают обработчиками персональных данных в соответствии со ст. 6 Федерального закона
                152-ФЗ и собственными политиками конфиденциальности:
              </p>
              <ul>
                <li>
                  <strong>ООО «ЯНДЕКС»</strong> — сервис веб-аналитики «Яндекс.Метрика», включая
                  технологию «Вебвизор». Передаются: IP-адрес, cookie-файлы, информация о браузере и
                  устройстве, действия Пользователя на страницах Сайта (в т.ч. движения курсора, клики,
                  заполнение полей форм за исключением полей, помеченных как конфиденциальные).
                  Цель — анализ посещаемости и улучшение работы Сайта. Политика конфиденциальности:{' '}
                  <a href="https://yandex.ru/legal/confidential/" target="_blank" rel="noopener noreferrer">
                    https://yandex.ru/legal/confidential/
                  </a>.
                </li>
                <li>
                  <strong>ООО «Новые облачные технологии» / UIS (uiscom.ru)</strong> — сервис
                  коллтрекинга и обработки телефонных обращений. Передаются: номер телефона,
                  cookie-файлы, IP-адрес, источник перехода. Цель — связь с Пользователем по входящему
                  звонку и анализ источников обращений. Политика конфиденциальности:{' '}
                  <a href="https://www.uiscom.ru/privacy/" target="_blank" rel="noopener noreferrer">
                    https://www.uiscom.ru/privacy/
                  </a>.
                </li>
                <li>
                  <strong>Мессенджеры WhatsApp (WhatsApp LLC) и Telegram (Telegram FZ-LLC).</strong>{' '}
                  На Сайте размещены ссылки на чаты Компании в указанных мессенджерах. При переходе
                  по таким ссылкам Пользователь покидает Сайт и попадает в среду стороннего сервиса.
                  В случае инициирования переписки сторонним сервисам становятся доступны: номер
                  телефона Пользователя, имя/никнейм, IP-адрес и иные технические данные в объёме,
                  определяемом политикой соответствующего мессенджера. Сайт не контролирует и не
                  несёт ответственность за обработку этих данных мессенджерами. Политики:{' '}
                  <a href="https://www.whatsapp.com/legal/privacy-policy" target="_blank" rel="noopener noreferrer">
                    WhatsApp
                  </a>
                  ,{' '}
                  <a href="https://telegram.org/privacy" target="_blank" rel="noopener noreferrer">
                    Telegram
                  </a>.
                </li>
              </ul>
              <p>
                Указанные сервисы хранят данные на территории Российской Федерации в соответствии со
                ст. 18 Федерального закона 152-ФЗ. Загрузка этих сервисов на Сайте происходит только
                после получения согласия Пользователя через cookie-баннер.
              </p>

              <p>
                <strong>3.4. Сроки обработки и хранения.</strong> Персональные данные обрабатываются в
                течение срока, необходимого для достижения целей обработки, но не более 5 (пяти) лет
                с момента последнего обращения Пользователя, либо до момента отзыва согласия. После
                истечения срока или отзыва согласия данные уничтожаются в течение 30 дней, если иное
                не предусмотрено законодательством РФ.
              </p>

              <h2>4. Обязательства сторон</h2>
              
              <p><strong>4.1.</strong> Пользователь обязуется предоставить корректную и правдивую информацию о персональных данных, необходимую для пользования Сайтом.</p>
              
              <p><strong>4.2.</strong> Администрация Сайта обязуется использовать полученную информацию исключительно для целей, указанных в настоящей Политике конфиденциальности.</p>
              
              <h2>5. Изменение и удаление персональной информации. Отзыв согласия</h2>
              
              <p><strong>5.1.</strong> Пользователь может в любой момент изменить (обновить, дополнить) предоставленную им персональную информацию или её часть, обратившись к Администрации Сайта по контактным данным, указанным на Сайте.</p>
              
              <p><strong>5.2.</strong> Пользователь также может отозвать свое согласие на обработку персональных данных путем направления письменного уведомления Оператору по адресу для корреспонденции (142119, а/я 479, Загибалова Марина Александровна) или на адрес электронной почты <a href="mailto:trigru@ya.ru">trigru@ya.ru</a>.</p>
              
              <h2>6. Меры, применяемые для защиты персональной информации пользователя</h2>
              
              <p><strong>6.1.</strong> Сайт принимает необходимые и достаточные организационные и технические меры для защиты персональной информации Пользователя от неправомерного или случайного доступа, уничтожения, изменения, блокирования, копирования, распространения, а также от иных неправомерных действий с ней третьих лиц.</p>
              
              <h2>7. Изменение Политики конфиденциальности. Применимое законодательство</h2>
              
              <p><strong>7.1.</strong> Администрация Сайта вправе вносить изменения в настоящую Политику конфиденциальности без согласия Пользователя. Новая редакция Политики вступает в силу с момента ее размещения на Сайте, если иное не предусмотрено новой редакцией Политики.</p>
              
              <p><strong>7.2.</strong> К настоящей Политике и отношениям между Пользователем и Администрацией Сайта, возникающим в связи с применением Политики конфиденциальности, подлежит применению право Российской Федерации.</p>
              
              <h2 id="consent">8. Согласие на обработку персональных данных</h2>

              <p>
                Отправляя форму обратной связи на Сайте и проставляя соответствующую отметку, Пользователь
                в соответствии со статьёй 9 Федерального закона от 27.07.2006 № 152-ФЗ «О персональных
                данных» свободно, своей волей и в своём интересе даёт согласие на обработку своих
                персональных данных на следующих условиях:
              </p>
              <p>
                <strong>Оператор:</strong> Индивидуальный предприниматель Загибалова Марина
                Александровна, ИНН 500403234260, ОГРНИП 325508100115316. Адрес для
                корреспонденции: 142119, а/я 479, Загибалова Марина Александровна.
                Телефон:{' '}
                <a href="tel:+79257166607">+7 (925) 716-66-07</a>. E-mail для обращений:{' '}
                <a href="mailto:trigru@ya.ru">trigru@ya.ru</a>.
              </p>
              <p>
                <strong>Перечень персональных данных:</strong> фамилия, имя; номер контактного телефона;
                адрес электронной почты (если указан Пользователем); cookie-файлы, IP-адрес, технические
                данные об устройстве и браузере при использовании Сайта.
              </p>
              <p>
                <strong>Цели обработки:</strong> обработка заявки и оказание консультаций по миграционным
                услугам и услугам перевода; связь с Пользователем по указанным контактам;
                информирование об услугах; учёт обращений; анализ посещаемости и улучшение работы Сайта.
              </p>
              <p>
                <strong>Перечень действий с персональными данными:</strong> сбор, запись, систематизация,
                накопление, хранение, уточнение (обновление, изменение), извлечение, использование,
                передача (предоставление, доступ) указанным в разделе 3.3 обработчикам, обезличивание,
                блокирование, удаление, уничтожение. Обработка осуществляется как с использованием
                средств автоматизации, так и без них.
              </p>
              <p>
                <strong>Срок действия согласия:</strong> согласие действует с момента его предоставления
                и до момента отзыва, но не более 5 (пяти) лет с даты последнего обращения. По истечении
                срока или после отзыва согласия данные подлежат уничтожению в порядке, предусмотренном
                разделом 3.4 настоящей Политики.
              </p>
              <p>
                <strong>Порядок отзыва согласия:</strong> Пользователь вправе в любой момент отозвать
                согласие, направив письменное уведомление на e-mail{' '}
                <a href="mailto:trigru@ya.ru">trigru@ya.ru</a>{' '}
                либо по адресу для корреспонденции: 142119, а/я 479, Загибалова Марина
                Александровна — с указанием ФИО и контактных данных, по которым осуществлялась
                связь.
              </p>

              <h2>9. Обратная связь. Вопросы и предложения</h2>
              
              <p>
                Все предложения или вопросы по поводу настоящей Политики Пользователь вправе направлять 
                Администрации Сайта по контактным данным, указанным в разделе «Контакты» на Сайте, или на 
                адрес электронной почты <a href="mailto:trigru@ya.ru">trigru@ya.ru</a>.
              </p>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Privacy;